import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  selectBillTotals,
  selectFinalTotals,
  selectMergedItems,
} from "../../reduxStore/selectors/cartSelectors";
import { formatCurrency } from "../../utils/currency";
import "./OrderBillDetails.css";

function OrderBillDetails(props) {
  const {
    selectedTable,
    pendingItems,
    discount: orderDiscount,
  } = useSelector((state) => state.cart);
  const mergedItems = useSelector(selectMergedItems);
  const bill = useSelector(selectBillTotals);
  const final = useSelector(selectFinalTotals);
  const hasDiscount = orderDiscount && orderDiscount.type !== null;
  return (
    <>
      <Box className="menu-item-bill">
        <Box className="menu-item-bill-title">Bill Details</Box>
        <Box>
          <Box className="menu-item-bill-item">
            <Box>Item</Box>
            <Box className="menu-item-bill-amount">
              {mergedItems?.length} (Items)
            </Box>
          </Box>
          <Box className="menu-item-bill-item">
            <Box>Item Amount</Box>
            <Box className="menu-item-bill-amount">
              {formatCurrency(final.payable)}
            </Box>
          </Box>
          {hasDiscount && (
            <Box className="menu-item-bill-item">
              <Box>Discount</Box>
              <Box className="menu-item-bill-amount">
                - {formatCurrency(final.discountAmount)}
              </Box>
            </Box>
          )}
          {/* <Box className="menu-item-bill-item">
            <Box>Delivery charges</Box>
            <Box className="menu-item-bill-amount">{formatCurrency(10)}</Box>
          </Box>
          <Box className="menu-item-bill-item">
            <Box>Tax(5%)</Box>
            <Box className="menu-item-bill-amount">{formatCurrency(30)}</Box>
          </Box> */}
          <Box className="menu-item-bill-item">
            <Box>SGST</Box>
            <Box className="menu-item-bill-amount">{formatCurrency(3)}</Box>
          </Box>
          <Box className="menu-item-bill-item">
            <Box>CGST</Box>
            <Box className="menu-item-bill-amount">{formatCurrency(3)}</Box>
          </Box>
          <Box className="menu-item-bill-item menu-bill-item-total">
            <Box>Total</Box>
            <Box className="menu-item-bill-amount">
              {formatCurrency(final.payable, true)}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default OrderBillDetails;
